import { TwoHeading } from "./TwoHeading";
import * as theme from "../theme";
import BackToApplication from "./BackToApplication";
import {
  getCovers,
  getCoverTable,
  updateCover,
  getResponseDetail,
  getCoverPlans,
  getCurrentCoversPlans,
  getCurrentCovers,
  getQuoteComment,
  getCoverTypes,
  updateCovers,
} from "../store/quotes";
import Select from "react-dropdown-select";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { applyInsurerPlan } from "../store/quotes";
import {
  Typography,
  Box,
  makeStyles,
  CircularProgress,
  TextField,
  Zoom,
  Tooltip,
} from "@material-ui/core";
import { verifyBrokerAgainstProspectQF, getFormState } from "../store/qf";
import { readyTheCards } from "../store/helperfuncs";
import { getCompareViewRows, updateRows } from "../store/compareview";
import AddEditSummary from "../components/AddEdit/AddEditSummary";
import TabPanel from "../components/AddEdit/TabPanel";
import CloudIcon from "../components/AddEdit/CloudIcon";
import { Constents } from "../components/AddEdit/Constant";
import Tabs from "../components/AddEdit/Tabs";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import _ from "lodash";
import { getBrokerInformation } from "../store/broker";

const useStyles = makeStyles((theme) => ({
  mainDiv: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  backbtnDiv: {
    alignItems: "center",
    display: "flex",
    paddingLeft: "3.5vw",
    paddingRight: "3.5vw",
    width: "100%",
  },
  SummaryDiv: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    paddingLeft: "1.5vw",
    height: "88vh",
  },
}));
const ReditLeftPane = (props) => {
  const prospectid = props.prospectid;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const responseid = props.responseid;
  const covers = useSelector(getCovers(responseid));
  const covertable = useSelector(getCoverTable);
  const coverPlans = useSelector(getCoverPlans);
  const covertypes = useSelector(getCoverTypes);
  const responseDetailData = useSelector(getResponseDetail(responseid));
  const responseComment = useSelector(getQuoteComment);
  var rows = useSelector(getCompareViewRows);
  const [updatedCovers, setUpdatedCoverTable] = useState(null);
  const [updatedLocCovers, setUpdatedLocCoverTable] = useState({});
  const [isUpdatingCovs, setIsUpdatingCovs] = useState(false);
  const [isCommentUpdating, setCommentUpdating] = useState(false);
  const [buffer, setBuffer] = useState(1);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const [cardsObject, setCardsObject] = useState(readyTheCards(rows, false));
  const [hideCommitButton, sethideCommitButton] = useState(true);
  const formState = useSelector(getFormState);
  const [buldingName, setBuildName] = useState("");
  const [nodestate, setNodestate] = useState("");
  const [hasBuilding, setHasBuilding] = useState(false);
  const [responseDetail, setResponseDetail] = useState(responseDetailData);
  const [PrefillCheckboxText, setPrefillCheckboxText] = useState({
    text:
      languagepreference === "en"
        ? "This package will overwrite any other packages previous added"
        : "Ce forfait effacera tous les autres forfaits ajoutés précédemment Enregistrer Ce texte s’écrit",
    checked: false,
  });
  var updatedRowsx = [];
  const classes = useStyles();

  const [title, setTitle] = useState(
    languagepreference === "en"
      ? "Policy Level Coverages"
      : "Couvertures d’assurance"
  );
  useEffect(() => {
    let locationObj = _.find(formState, (obj) => obj.type === "location");
    if (locationObj?.nodestate) {
      setNodestate(locationObj.nodestate);
      // Check for a key with "building" in nodestate
      // const hasBuilding = Object.keys(locationObj.nodestate).some((key) =>
      //   key.includes("building")
      // );

      // Check if the location and buildings are defined and have the necessary structure
      let hasBuilding = false;
      if (
        locationObj.locationstate &&
        locationObj.locationstate[1] &&
        locationObj.locationstate[1].buildings &&
        locationObj.locationstate[1].buildings[0] &&
        Array.isArray(locationObj.locationstate[1].buildings[0].groupsorder)
      ) {
        // Check if groupsorder array has any elements
        hasBuilding =
          locationObj.locationstate[1].buildings[0].groupsorder.length > 0;
      }

      setHasBuilding(hasBuilding);
    } else {
      setHasBuilding(false);
    }
  }, [formState]);

  useEffect(() => {
    dispatch(getCurrentCovers(responseid));
    dispatch(getCurrentCoversPlans(responseid));
    let newRows = [...rows];
    for (let idx in newRows) {
      if (newRows[idx].covervalue) {
        newRows[idx] = { ...newRows[idx], otherinfo: "manual_input" };
      }
    }
    dispatch(updateRows({ rows: newRows }));
  }, []);

  useEffect(() => {
    if (responseDetail?.locations) {
      //console.log("Re-assigning location covers")
      setUpdatedLocCoverTable(Object.assign({}, responseDetail?.locations));
    }
    console.log("show me the response", responseDetail);
  }, [responseDetail]);

  const setValue = ({ value, id, isLocCov, locNum, comment, card }) => {
    if (responseDetail?.source == "manual" || true) {
      let locTable = null;
      let policyTable = null;
      let newRows = [...rows];

      const price_quoted_keys = [207, 4, 206];
      const index = rows.findIndex((el) => {
        if (el.id === id) {
          if (el.locationid) {
            if (el.locationid === locNum) return true;
            else return false;
          }
          return true;
        }
      });
      newRows[index] = {
        ...newRows[index],
        covervalue: value,
        otherinfo: "manual_input",
      };
      var newCovers = { ...covers, [id]: value };
      // if block to auto update price_quoted
      if (price_quoted_keys.includes(id)) {
        var updated_covers = { ...covers, [id]: value };
        const sum = Object.keys(updated_covers)
          .filter((key) => price_quoted_keys.includes(parseInt(key)))
          .reduce((acc, Filteredkey) => {
            if (!updated_covers[Filteredkey]) {
              updated_covers[Filteredkey] = 0;
            }
            return parseFloat(acc) + parseFloat(updated_covers[Filteredkey]);
          }, 0);
        console.log(
          Object.keys(updated_covers)
            .filter((key) => price_quoted_keys.includes(parseInt(key)))
            .map((x) => updated_covers[x])
        );
        newCovers = { ...covers, [id]: value, 3: sum };
        const indexTotalQuoted = rows.findIndex((el) => {
          if (el.id === 3) {
            return true;
          }
        });
        newRows[indexTotalQuoted] = {
          ...newRows[indexTotalQuoted],
          covervalue: sum,
          otherinfo: "manual_input",
        };
      }
      //comment ,sending errors to console
      dispatch(
        updateCovers({
          responseid: responseid,
          covers: { ...newCovers },
        })
      );
      // console.log("line 135")
      // dispatch(updateRows({ rows: newRows }));
      if (id) {
        if (isLocCov) {
          const buildingId = card[0].buildingId - 1; // need to convert into correct building counting format

          var tmp = {};
          for (let key in updatedLocCovers) {
            tmp[key] = _.cloneDeep(updatedLocCovers[key]); // { ...updatedLocCovers[key] }
          }

          if (!tmp[locNum]) tmp[locNum] = {};
          //because building count starts from 0 it will always be false so we need to check if its true
          if (buildingId || buildingId === 0) {
            // Check for buildingId existence
            if (!tmp[locNum][`buildings`]) {
              tmp[locNum][`buildings`] = {}; // Initialize as an object
            }
            if (!tmp[locNum][`buildings`][buildingId]) {
              tmp[locNum][`buildings`][buildingId] = {};
            }

            tmp[locNum][`buildings`][buildingId][id] = value;
          } else {
            tmp[locNum][id] = value;
          }
          setUpdatedLocCoverTable(tmp);
          if (hasBuilding) {
            //we need to store the changes made locally or if use clicks away it will not be reflected until the refresh the page
            var tempResponseDetail = _.cloneDeep(responseDetail);

            tempResponseDetail.locations = tmp;
            setResponseDetail(tempResponseDetail);
          }
        } else {
          policyTable = JSON.parse(JSON.stringify(newCovers));
          if (!policyTable) policyTable = {};
          policyTable[id] = value;
          setUpdatedCoverTable(policyTable);
        }
      }

      dispatch(
        updateCover({
          responseid: responseid,
          policydata: policyTable ? policyTable : null,
          locationdata: tmp ? tmp : null,
          comment: comment ? comment : null,
        })
      );
      dispatch(updateRows({ rows: newRows }));
      setCardsObject(readyTheCards(newRows, hasBuilding));
      // console.log(newRows.find(x => x.id == 13))
    }
  };

  let applyPlan = (e) => {
    if (!e || !e[0]) return;
    let newPlans = e[0].value;
    let updatedRows = [];
    let changedRows = [];
    //let LocationCovers = covertable.map(x => x.covertypecode == "LOCATION").map(t => t.id);
    var locTable = {}; //Object.assign({}, responseDetail.locations);
    for (var Buildingkey in responseDetail.locations) {
      locTable[Buildingkey] = { ...responseDetail.locations[Buildingkey] };
    }

    for (var c = 0; c < rows.length; c++) {
      updatedRows[c] = { ...rows[c] };
      let newValue = newPlans.find((x) => x.coverid == updatedRows[c].id);
      if (newValue?.value == "" && PrefillCheckboxText.checked) {
        continue;
      }
      if (updatedRows[c].covervalue != "" && PrefillCheckboxText.checked) {
        continue;
      }
      if (
        newValue &&
        (!["manual_input"].includes(updatedRows[c].otherinfo) ||
          ["", "0", 0].includes(updatedRows[c].covervalue))
      ) {
        updatedRows[c].covervalue = newValue.value;
        updatedRows[c].otherinfo = "mass_updated";
        changedRows.push(updatedRows[c]);
      } else if (
        updatedRows[c].otherinfo == "mass_updated" &&
        !PrefillCheckboxText.checked
      ) {
        updatedRows[c].covervalue = "";
      }

      if (covertable[updatedRows[c].id]?.covertypecode == "LOCATION") {
        for (var Buildingkey in responseDetail.locations) {
          locTable[Buildingkey][updatedRows[c].id] = updatedRows[c].covervalue;
        }
      }
    }
    setUpdatedLocCoverTable(locTable);
    dispatch(updateRows({ rows: updatedRows }));
    setCardsObject(readyTheCards(updatedRows, hasBuilding));
    sethideCommitButton(false);
    let oldBuffer = buffer;
    if (buffer == 1) {
      setBuffer(2);
    } else {
      setBuffer(1);
    }
    return;
  };

  useEffect(() => {
    if (prospectid) {
      dispatch(
        verifyBrokerAgainstProspectQF({
          prospectid: prospectid,
        })
      );
    }
  }, [prospectid]);

  useEffect(() => {
    if (covers && !updatedCovers) {
      setUpdatedCoverTable(covers);
    } else if (covertable && !updatedCovers) {
      let templateCovers = {};
      for (let coverid in covertable) {
        templateCovers[coverid] = "";
      }
      setUpdatedCoverTable(templateCovers);
    }
  }, [prospectid]);

  useEffect(() => {
    setCardsObject(readyTheCards(rows, hasBuilding));
    //const timer = setTimeout(setBuffer(oldBuffer),2500);
    //return () => clearTimeout(timer);
  }, [rows, hasBuilding]);

  const getLocationCovers = (card, buildingKey, index) => {
    const locationId = card[buildingKey][0].locationid || index + 1;
    if (
      responseDetail?.locations &&
      responseDetail.locations[locationId] &&
      responseDetail.locations[locationId][buildingKey]
    ) {
      return responseDetail.locations[locationId][buildingKey];
    }
    return undefined; // or a default value if needed
  };

  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";

  return (
    <div className={classes.mainDiv}>
      <div
        style={{ height: heightDivison.backtoapp }}
        className={classes.backbtnDiv}
      >
        <BackToApplication
          text={Constents.BACK_BTN[languagepreference]}
          onClick={() => {
            //navigate("/quotes?id=" + prospectid)
            document.location.href = "/quotes?id=" + prospectid;
          }}
        ></BackToApplication>
      </div>
      <div
        style={{
          height: heightDivison.quoteresults,
          width: "100%",
          display: "flex",
          paddingLeft: mainContMargin,
        }}
      >
        <TwoHeading
          heading1={Constents.HEADING[languagepreference]}
          heading2={Constents.SUB_HEADING[languagepreference]}
        ></TwoHeading>
        <div
          style={{
            display: "grid",
            marginLeft: "6%",
            gridTemplateColumns: "1fr .6fr",
            gridTemplateRows: "repeat(2, 1fr)",
            gridColumnGap: "0px",
            gridRowGap: "0px",
            marginLeft: "auto",
            maxHeight: "26px",
          }}
        >
          <Select
            // searchable={false}
            searchBy="label"
            valueField="label"
            isMulti={false}
            placeholder={
              languagepreference === "en"
                ? "Choose insurance package"
                : "Choisir un forfait d’assurance"
            }
            color={theme.COLORS.primary_navyblue}
            onChange={(values) => applyPlan(values)}
            options={coverPlans}
            style={{
              width: "18em",
              height: "6vh",
              gridArea: "1 / 1 / 2 / 2",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
          />
          {hideCommitButton ? null : (
            <Button
              style={{
                color: "white",
                height: "4.5vh",
                gridArea: "1 / 2 / 2 / 3",
                fontFamily: "GibsonSemiBd",
                fontSize: 20,
                backgroundColor: theme.COLORS.secondary_skyblue,
                border: 0,
                margin: "8px 0 0 2rem",
                width: "5vw",
              }}
              onClick={() => {
                let policydata = {};
                let tmp_locdata = { ...updatedLocCovers };

                tmp_locdata = rows
                  .filter(
                    (x) => x.locationid && x.covervalue && x.covervalue != ""
                  )
                  .reduce((tobj, inp) => {
                    if (tobj && !tobj[inp.locationid]) {
                      tobj[inp.locationid] = {};
                    }
                    tobj[inp.locationid][inp.id] = inp.covervalue;
                    return tobj;
                  }, {});
                for (let covertypecode in cardsObject) {
                  // Check if the property is actually an array before iterating
                  if (Array.isArray(cardsObject[covertypecode])) {
                    for (let cover of cardsObject[covertypecode]) {
                      policydata[cover.id] = cover.covervalue;
                    }
                  } else {
                    continue;
                  }
                }
                setUpdatedLocCoverTable(tmp_locdata);
                dispatch(
                  updateCover({
                    responseid: responseid,
                    policydata: policydata,
                    locationdata: tmp_locdata,
                    comment: null,
                  })
                );
                setUpdatedCoverTable(policydata);
                var newCovers = rows
                  .filter((x) => x.covervalue != "" && x.covervalue)
                  .reduce(
                    (obj, item) => ((obj[item.id] = item.covervalue), obj),
                    {}
                  );

                dispatch(
                  updateCovers({
                    responseid: responseid,
                    covers: newCovers,
                  })
                );
                toast.success("Applied Plan Successfully");
              }}
            >
              {languagepreference === "en" ? "Save" : "Enregistrer"}
            </Button>
          )}
          <Form.Check
            inline
            label={PrefillCheckboxText.text}
            name="group1"
            type="checkbox"
            style={{
              marginTop: "6px",
              gridArea: "2 / 1 / 3 / 3",
              fontSize: 15,
              fontFamily: "GibsonRegular",
              color: "gray",
            }}
            id={`inline-checkbox-1`}
            onClick={(e) => {
              if (!e.target.checked) {
                setPrefillCheckboxText({
                  text:
                    languagepreference === "en"
                      ? "This package will overwrite any other packages previous added"
                      : "Ce forfait effacera tous les autres forfaits ajoutés précédemment Enregistrer Ce texte s’écrit",
                  checked: false,
                });
              } else {
                setPrefillCheckboxText({
                  text:
                    languagepreference === "en"
                      ? "This package will overwrite any other packages previous added"
                      : "Ce forfait effacera tous les autres forfaits ajoutés précédemment Enregistrer Ce texte s’écrit",
                  checked: false,
                });
              }
            }}
          />
        </div>
      </div>
      <div style={{ height: heightDivison.spaceBetweenHeaderContent }}></div>
      <div
        style={{
          paddingLeft: "3.5vw",
          paddingRight: "3.5vw",
          paddingTop: "1vw",
        }}
      >
        <div className={classes.SummaryDiv}>
          <div>
            <div style={{}}>
              {/* <PerfectScrollbar> */}
              {Object.keys(cardsObject).map((key, index) => {
                if (key == "RESPONSE")
                  return (
                    <AddEditSummary
                      key={index}
                      responseid={responseid}
                      setValue={setValue}
                      card={cardsObject[key]}
                    ></AddEditSummary>
                  );
              })}
              {/* </PerfectScrollbar> */}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingBottom: "1vh",
                paddingTop: "3vh",
              }}
            >
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ ...theme.labelStyles }}
                >
                  {Constents.QUOTES_NOTES[languagepreference]}
                </Typography>
                <CloudIcon isUpdating={isCommentUpdating} />
              </div>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={2}
                variant="outlined"
                placeholder={
                  responseComment
                    ? responseComment
                    : Constents.COMMENT_TEXT[languagepreference]
                }
                style={{ backgroundColor: "white" }}
                onBlur={(event) => {
                  setCommentUpdating(true);
                  setTimeout(() => {
                    setValue({ comment: event.target.value });
                    setValue({ value: event.target.value, id: 2 });
                    setCommentUpdating(false);
                  }, 400);
                }}
              />
            </div>
          </div>
          <div style={{ margin: "0 2.5rem" }}>
            <div>
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ ...theme.labelStyles }}
                >
                  {title}
                </Typography>
                <CloudIcon isUpdating={isUpdatingCovs} />
              </div>
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <Tabs
                  buffer={buffer}
                  setBuffer={setBuffer}
                  cardsObject={cardsObject}
                  setTitle={setTitle}
                  covertypes={covertypes}
                ></Tabs>
                {Object.keys(cardsObject).map((key, index) => {
                  if (key == "RESPONSE") return <div key={index} />;
                  else {
                    const card = cardsObject[key];
                    if (Array.isArray(card)) {
                      return (
                        <TabPanel
                          card={card}
                          key={index}
                          value={buffer}
                          responseid={props.responseid}
                          cardname={key}
                          index={index}
                          locNum={
                            card[0].locationid ? card[0].locationid : index + 1
                          }
                          locationCovers={
                            responseDetail?.locations?.[
                              card[0].locationid
                                ? card[0].locationid
                                : index + 1
                            ]
                          }
                          setUpdating={setIsUpdatingCovs}
                          getUpdating={isUpdatingCovs}
                          setValue={setValue}
                          covertable={covertable}
                          style={{ width: "80%", overflow: "hidden" }}
                          responseid={responseid}
                        ></TabPanel>
                      );
                    } else {
                      return (
                        <div
                          style={{
                            padding: buffer === index ? "20px" : "0px",
                            width: buffer === index ? "100%" : "0px",
                          }}
                        >
                          <Accordion
                            hidden={buffer !== index}
                            defaultActiveKey="0"
                          >
                            {Object.keys(card).map(
                              (buildingKey, buildingIndex) => {
                                return (
                                  <Card key={buildingKey}>
                                    <Accordion.Toggle
                                      as={Card.Header}
                                      eventKey={buildingIndex.toString()}
                                    >
                                      {nodestate[
                                        `location_${card[buildingKey][0].locationid}_building_${buildingIndex}_59000a`
                                      ]?.answer
                                        ? nodestate[
                                            `location_${card[buildingKey][0].locationid}_building_${buildingIndex}_59000a`
                                          ].answer
                                        : "Property " + (buildingIndex + 1)}
                                      {/* location_1_building_0_59000a */}
                                    </Accordion.Toggle>
                                    <Accordion.Collapse
                                      eventKey={buildingIndex.toString()}
                                    >
                                      <Card.Body>
                                        <TabPanel
                                          card={card[buildingKey]}
                                          key={buildingKey}
                                          buildingKey={buildingIndex}
                                          value={buffer}
                                          responseid={props.responseid}
                                          cardname={key + "-" + buildingKey}
                                          index={index}
                                          locNum={
                                            card[buildingKey][0]?.locationid
                                              ? card[buildingKey][0]?.locationid
                                              : index + 1
                                          }
                                          locationCovers={
                                            responseDetail?.locations?.[
                                              card[buildingKey][0]
                                                ?.locationid ?? index + 1
                                            ]?.buildings?.[buildingIndex] ?? []
                                          }
                                          setUpdating={setIsUpdatingCovs}
                                          getUpdating={isUpdatingCovs}
                                          setValue={setValue}
                                          covertable={covertable}
                                          style={{
                                            width: "80%",
                                            overflow: "hidden",
                                          }}
                                          responseid={responseid}
                                        ></TabPanel>
                                      </Card.Body>
                                    </Accordion.Collapse>
                                  </Card>
                                );
                              }
                            )}
                          </Accordion>
                        </div>
                      );
                    }
                  }
                })}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReditLeftPane;
